import { resolveValue } from 'components/form/final-form/useField'
import { Calculation } from 'final-form-calculate'
import { AtendimentoIndividualViewQuery } from 'graphql/types.generated'
import { ProcedimentosAutomaticosAtendimentoIndividual } from 'types/enums'
import { MetaArray, MetaPath } from 'util/metaPath'
import { v4 as uuidv4 } from 'uuid'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { MedicoesPanelModel } from 'view/atendimentos/components/MedicoesPanel/MedicoesPanel'

import { ProcedimentoPlanoModel } from './components/ProcedimentoPlanoField'
import { PlanoFormModel } from './PlanoForm'

export const createPlanoCalculations = (
  plano: MetaPath<PlanoFormModel>,
  medicoes: MetaPath<MedicoesPanelModel>,
  procedimentosAutomaticos: AtendimentoIndividualViewQuery['procedimentosAutomaticos']
): Calculation[] => [
  {
    field: [medicoes.peso.absolutePath(), medicoes.altura.absolutePath()],
    updates: {
      [plano.procedimentos.absolutePath()]: (
        values: MetaArray<ProcedimentoPlanoModel>,
        allValues: SoapState,
        prevValues: SoapState
      ) => {
        const listaProcedimentos = addProcedimentoAutomatico(
          allValues,
          prevValues,
          plano.procedimentos,
          procedimentosAutomaticos,
          ProcedimentosAutomaticosAtendimentoIndividual.AVALIACAO_ANTROPOMETRICA
        )
        return resolveValue(allValues, medicoes.peso) && resolveValue(allValues, medicoes.altura)
          ? listaProcedimentos
          : removeProcedimentoAutomatico(
              listaProcedimentos,
              ProcedimentosAutomaticosAtendimentoIndividual.AVALIACAO_ANTROPOMETRICA
            )
      },
    },
  },
  {
    field: [medicoes.pressaoArterialSistolica.absolutePath(), medicoes.pressaoArterialDiastolica.absolutePath()],
    updates: {
      [plano.procedimentos.absolutePath()]: (
        values: MetaArray<ProcedimentoPlanoModel>,
        allValues: SoapState,
        prevValues: SoapState
      ) => {
        const listaProcedimentos = addProcedimentoAutomatico(
          allValues,
          prevValues,
          plano.procedimentos,
          procedimentosAutomaticos,
          ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_PRESSAO_ARTERIAL
        )
        return resolveValue(allValues, medicoes.pressaoArterialSistolica) &&
          resolveValue(allValues, medicoes.pressaoArterialDiastolica)
          ? listaProcedimentos
          : removeProcedimentoAutomatico(
              listaProcedimentos,
              ProcedimentosAutomaticosAtendimentoIndividual.AFERICAO_PRESSAO_ARTERIAL
            )
      },
    },
  },
  {
    field: medicoes.glicemia.absolutePath(),
    updates: {
      [plano.procedimentos.absolutePath()]: (
        values: MetaArray<ProcedimentoPlanoModel>,
        allValues: SoapState,
        prevValues: SoapState
      ) => {
        const listaProcedimentos = addProcedimentoAutomatico(
          allValues,
          prevValues,
          plano.procedimentos,
          procedimentosAutomaticos,
          ProcedimentosAutomaticosAtendimentoIndividual.GLICEMIA_CAPILAR
        )
        return resolveValue(allValues, medicoes.glicemia)
          ? listaProcedimentos
          : removeProcedimentoAutomatico(
              listaProcedimentos,
              ProcedimentosAutomaticosAtendimentoIndividual.GLICEMIA_CAPILAR
            )
      },
    },
  },
]

const addProcedimentoAutomatico = (
  allValues: SoapState,
  prevValues: SoapState,
  existedProcedimentos: MetaArray<ProcedimentoPlanoModel>,
  procedimentosAutomaticos: AtendimentoIndividualViewQuery['procedimentosAutomaticos'],
  procedimentoAutomaticoEnum: ProcedimentosAutomaticosAtendimentoIndividual
) => {
  const procedimento: ProcedimentoPlanoModel = {
    _id: uuidv4(),
    procedimento: procedimentosAutomaticos.find((p) => p.codigo === procedimentoAutomaticoEnum),
    automatico: true,
  }

  const prevValuesNotEmpty = resolveValue(prevValues, existedProcedimentos)
  const values = resolveValue(allValues, existedProcedimentos) || ([] as ProcedimentoPlanoModel[])

  if (Array.isArray(values) && procedimento.procedimento) {
    if (!values.find((p) => p.procedimento.id === procedimento.procedimento.id) && prevValuesNotEmpty) {
      values.push(procedimento)
    }
  }

  return values
}

const removeProcedimentoAutomatico = (
  listaProcedimentos: ProcedimentoPlanoModel | ProcedimentoPlanoModel[],
  procedimentoAutomaticoEnum: ProcedimentosAutomaticosAtendimentoIndividual
) => {
  if (Array.isArray(listaProcedimentos)) {
    return listaProcedimentos.filter((p) => (p.automatico ? p.procedimento.codigo !== procedimentoAutomaticoEnum : p))
  }
}
